module.exports = __webpack_public_path__ + "img/findAnswer.1800f162.jpg";